import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.netmart');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-netmart',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.netmart/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.netmart-page {
  position: relative;
  isolation: isolate;
  min-height: 100svh;
  overflow: hidden;
  background: linear-gradient(150deg, #090d12 0%, #111820 52%, #090d12 100%);
}

.market-glow {
  position: absolute;
  z-index: -2;
  top: -320px;
  right: -200px;
  width: 760px;
  height: 760px;
  border-radius: 9999px;
  background: radial-gradient(circle, rgba(190, 242, 100, 0.13), transparent 68%);
}

.market-grid {
  position: absolute;
  z-index: -1;
  inset: 0;
  opacity: 0.18;
  background-image: linear-gradient(rgba(148, 163, 184, 0.12) 1px, transparent 1px), linear-gradient(90deg, rgba(148, 163, 184, 0.12) 1px, transparent 1px);
  background-size: 52px 52px;
  mask-image: linear-gradient(110deg, black, transparent 80%);
  -webkit-mask-image: linear-gradient(110deg, black, transparent 80%);
}

.market-mark {
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  color: #bef264;
  border: 1px solid rgba(190, 242, 100, 0.2);
  border-radius: 14px;
  background: rgba(190, 242, 100, 0.08);
}

.market-status {
  width: 7px;
  height: 7px;
  border-radius: 9999px;
  background: #bef264;
  animation: market-pulse 2.2s ease-out infinite;
}

.market-stage {
  padding: 24px;
}

.product-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  transform: rotate(-2deg);
}

.product-card {
  min-height: 170px;
  padding: 18px;
  border: 1px solid rgba(255, 255, 255, 0.09);
  border-radius: 23px;
  background: rgba(255, 255, 255, 0.055);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(14px);
}

.product-icon {
  display: block;
  height: 90px;
  border-radius: 16px;
  background: linear-gradient(145deg, rgba(190, 242, 100, 0.18), rgba(132, 204, 22, 0.05));
}

.product-b .product-icon {
  background: linear-gradient(145deg, rgba(56, 189, 248, 0.18), rgba(14, 165, 233, 0.04));
}

.product-c .product-icon {
  background: linear-gradient(145deg, rgba(251, 146, 60, 0.18), rgba(249, 115, 22, 0.04));
}

.product-d .product-icon {
  background: linear-gradient(145deg, rgba(244, 114, 182, 0.18), rgba(236, 72, 153, 0.04));
}

.product-name,
.product-price {
  display: block;
  height: 6px;
  margin-top: 13px;
  border-radius: 9999px;
  background: rgba(226, 232, 240, 0.16);
}

.product-name {
  width: 68%;
}

.product-price {
  width: 42%;
  margin-top: 8px;
  background: rgba(190, 242, 100, 0.35);
}

.product-b,
.product-d {
  transform: translateY(24px);
}

.cart-badge {
  display: flex;
  position: absolute;
  right: 2px;
  bottom: 2px;
  width: 64px;
  height: 64px;
  align-items: center;
  justify-content: center;
  color: #111820;
  border-radius: 21px;
  background: #bef264;
  box-shadow: 0 20px 45px rgba(0, 0, 0, 0.34);
  animation: cart-float 4s ease-in-out infinite;
}

.cart-badge span {
  display: flex;
  position: absolute;
  top: -6px;
  right: -6px;
  width: 23px;
  height: 23px;
  align-items: center;
  justify-content: center;
  color: white;
  border: 3px solid #111820;
  border-radius: 9999px;
  background: #f97316;
  font-size: 9px;
  font-weight: 800;
}

@keyframes market-pulse {
  70% {
    box-shadow: 0 0 0 9px rgba(190, 242, 100, 0);
  }
}
@keyframes cart-float {
  50% {
    transform: translateY(-8px);
  }
}
@media (max-width: 640px) {
  .product-card {
    min-height: 145px;
  }
  .product-icon {
    height: 70px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .market-status, .cart-badge {
    animation: none;
  }
}`],
})
export class PageNetmartComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public navigateHome(event?: MouseEvent) {
        if (!event || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
            return;
        }

        event.preventDefault();
        this.service.href('/');
    }
}

export default PageNetmartComponent;